import React from 'react';
import Button from '../components/ui/Button';

const Hero: React.FC = () => {
  return (
    <section id="home" className="pt-28 pb-20 md:pt-36 md:pb-24 bg-[#FAFAF5] relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://images.pexels.com/photos/323705/pexels-photo-323705.jpeg?auto=compress&cs=tinysrgb&w=1920')] bg-cover bg-center opacity-20"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-abadi text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-4 animate-fade-in">
            Your Property. Our Priority.
          </h1>
          <p className="text-lg md:text-xl text-dark font-medium mb-10 animate-slide-up">
            RentSparks offers tech-savvy, high-touch property management services. Learn about our comprehensive, streamlined solutions for your investment properties.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-12">
            <Button 
              variant="custom"
              size="lg"
              className="bg-[#f0ffb2] hover:bg-[#f0ffb2]/90 text-dark"
              onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Learn More
            </Button>
            <Button 
              variant="custom"
              size="lg"
              className="bg-[#f0ffb2] hover:bg-[#f0ffb2]/90 text-dark"
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Choose Your Plan
            </Button>
            <Button 
              variant="custom"
              size="lg"
              className="bg-[#f0ffb2] hover:bg-[#f0ffb2]/90 text-dark"
              onClick={() => document.getElementById('blog')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Explore Insights
            </Button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#FAFAF5] to-transparent"></div>
    </section>
  );
};

export default Hero;